'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(ConsentName2) {
  ConsentName2["EMAIL"] = "EMAIL";
  ConsentName2["SMS"] = "SMS";
  ConsentName2["TELEPHONE"] = "TELEPHONE";
  ConsentName2["MAIL"] = "POST_MAIL";
  ConsentName2["ONSITE_MARKETING"] = "ONSITE_PERSONALISED_MARKETING";
  ConsentName2["TERMS"] = "TERMS_AND_CONDITIONS";
  ConsentName2["EMAIL_GIG"] = "EMAIL_GIG";
  ConsentName2["SMS_GIG"] = "SMS_GIG";
  ConsentName2["TELEPHONE_GIG"] = "TELEPHONE_GIG";
  ConsentName2["MAIL_GIG"] = "POST_MAIL_GIG";
  ConsentName2["PRIVACY_COOKIE_POLICY"] = "PRIVACY_AND_COOKIE_NOTICE";
  ConsentName2["DETAILS_REVERIFICATION"] = "DETAILS_REVERIFICATION";
})(exports.ConsentName || (exports.ConsentName = {}));
